module.exports = __webpack_public_path__ + "550caa4e7e88ad045d5d6b952fa1b2f1.fbx";